import React, { Component } from 'react';
import styled from 'styled-components';

import { messages } from './messages';
import { SiteSelectorView } from './site-selector-view';

import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';

export type SiteSelectorModalProps = {
  readonly isOpen: boolean;

  readonly userName: string;
  readonly userEmail: string;
  readonly avatarSrc?: string;

  readonly sites: string[];

  readonly header?: React.ReactNode;

  readonly onNewSiteSelected: () => void;
  readonly onSiteSelected: (site: string) => void;
  readonly onSiteChanged?: () => void;
  readonly onSwitchAccountClick: () => void;
  readonly onModalClose?: () => void;
};

export class SiteSelectorModal extends Component<SiteSelectorModalProps> {
  static messages = messages;

  static defaultProps = {
    // Default onModalClose and onSiteChanged handler doesn't need to do anything
    // tslint:disable-next-line:no-empty
    onModalClose: () => {},
    // tslint:disable-next-line:no-empty
    onSiteChanged: () => {}
  };

  onClose = () => {
    this.props.onModalClose!();
  };

  render() {
    const {
      userName,
      userEmail,
      avatarSrc,
      isOpen,
      header,
      sites,
      onNewSiteSelected,
      onSiteSelected,
      onSwitchAccountClick,
      onSiteChanged
    } = this.props;

    return (
      <ModalTransition>
        {isOpen && (
          <ModalDialog onClose={this.onClose} autoFocus={false}>
            <Container>
              <SiteSelectorView
                userName={userName}
                userEmail={userEmail}
                avatarSrc={avatarSrc}
                sites={sites}
                header={header}
                onNewSiteSelected={onNewSiteSelected}
                onSiteSelected={onSiteSelected}
                onSwitchAccountClick={onSwitchAccountClick}
                onCancelClick={this.onClose}
                onSiteChanged={onSiteChanged!}
              />
            </Container>
          </ModalDialog>
        )}
      </ModalTransition>
    );
  }
}

const Container = styled.div`
  margin: 22px 0px;
`;
